import { create } from "zustand";
import { EquatorialEnergyDetailedMeasurementFiltersMapping } from "../EquatorialEnergyDetailedMeasurementFilters";

const useSelectedMeasurementStore = create(set => ({
  selectedMeasurement: EquatorialEnergyDetailedMeasurementFiltersMapping.vrms,
  setSelectedMeasurement: selectedMeasurement => set({ selectedMeasurement })
}));

export default useSelectedMeasurementStore;
